import { _ as _objectWithoutProperties, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-blockquote-1-6-0{position:relative;margin:0 0 12px;padding:12px 0 0 34px}@media (min-width:600px){.hcr-blockquote-1-6-0{padding:12px 0 0 56px}}.hcr-blockquote-1-6-0:before{position:absolute;top:0;left:0;width:22px;height:14px;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg data-name='Ebene 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 159.8 100'%3E%3Cpath d='M159.4 62.9A32.2 32.2 0 00129 35.7c3.7-13.8 12.8-19.4 23.8-22.5a1.3 1.3 0 00.9-1.4l-1.8-11s-.2-.9-1.6-.7c-38 4.3-63.7 33.2-58.9 68.3 4.4 24.3 23.4 33.7 41 31.2a32.4 32.4 0 0027-36.7zM38.1 35.7c3.6-13.8 13-19.4 23.8-22.5a1.3 1.3 0 00.9-1.4L61.2.8s-.2-1-1.6-.8C21.6 4.1-3.9 33 .5 68.2c4.6 24.5 23.8 33.9 41.2 31.4a32.1 32.1 0 0026.8-36.7 31.7 31.7 0 00-30.4-27.2z' fill='%238c8c8c'/%3E%3C/svg%3E\") no-repeat;content:\"\"}@media (min-width:600px){.hcr-blockquote-1-6-0:before{width:44px;height:28px}}",
map:{"hcr-blockquote":"hcr-blockquote-1-6-0"}};

var bem = Bem('blockquote', styles);
var Blockquote = function Blockquote(_ref) {
  var extraClasses = _ref.extraClasses,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["extraClasses", "children"]);

  return React.createElement("blockquote", _extends({
    className: bem.b(false, extraClasses)
  }, rest), children);
};
Blockquote.displayName = 'Blockquote';
Blockquote.defaultProps = {
  extraClasses: ''
};
Blockquote.propTypes = {
  /** Injection in className */
  extraClasses: PropTypes.string,

  /** Children are required */
  children: PropTypes.node.isRequired
};
var blockquote = Injecss(Blockquote, styles);

export { blockquote as Blockquote };
